// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICalculateScheduleRequestDto } from './ICalculateScheduleRequestDto';
import {
    ICalculateScheduleRequestDtoFromJSON,
    ICalculateScheduleRequestDtoFromJSONTyped,
    ICalculateScheduleRequestDtoToJSON,
    ICalculateScheduleRequestDtoToJSONTyped,
} from './ICalculateScheduleRequestDto';

/**
 * 
 * @export
 * @interface IPayrollCalendarPartnerRequestDto
 */
export interface IPayrollCalendarPartnerRequestDto {
    /**
     * 
     * @type {string}
     * @memberof IPayrollCalendarPartnerRequestDto
     */
    calendar_name: string;
    /**
     * 
     * @type {string}
     * @memberof IPayrollCalendarPartnerRequestDto
     */
    frequency_type: IPayrollCalendarPartnerRequestDtoFrequencyTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IPayrollCalendarPartnerRequestDto
     */
    group_type: IPayrollCalendarPartnerRequestDtoGroupTypeEnum;
    /**
     * 
     * @type {ICalculateScheduleRequestDto}
     * @memberof IPayrollCalendarPartnerRequestDto
     */
    calculate_schedule_request_dto: ICalculateScheduleRequestDto;
    /**
     * 
     * @type {Set<number>}
     * @memberof IPayrollCalendarPartnerRequestDto
     */
    plan_ids?: Set<number>;
    /**
     * 
     * @type {Set<number>}
     * @memberof IPayrollCalendarPartnerRequestDto
     */
    payroll_group_ids?: Set<number>;
    /**
     * 
     * @type {number}
     * @memberof IPayrollCalendarPartnerRequestDto
     */
    organization_id: number;
}

/**
* @export
* @enum {string}
*/
export enum IPayrollCalendarPartnerRequestDtoFrequencyTypeEnum {
    WEEKLY = 'WEEKLY',
    BI_WEEKLY = 'BI_WEEKLY',
    MONTHLY = 'MONTHLY',
    SEMI_MONTHLY = 'SEMI_MONTHLY',
    ANNUALLY = 'ANNUALLY'
}
/**
* @export
* @enum {string}
*/
export enum IPayrollCalendarPartnerRequestDtoGroupTypeEnum {
    ALL = 'ALL',
    GROUP = 'GROUP',
    PLAN = 'PLAN'
}


/**
 * Check if a given object implements the IPayrollCalendarPartnerRequestDto interface.
 */
export function instanceOfIPayrollCalendarPartnerRequestDto(value: object): value is IPayrollCalendarPartnerRequestDto {
    if (!('calendar_name' in value) || value['calendar_name'] === undefined) return false;
    if (!('frequency_type' in value) || value['frequency_type'] === undefined) return false;
    if (!('group_type' in value) || value['group_type'] === undefined) return false;
    if (!('calculate_schedule_request_dto' in value) || value['calculate_schedule_request_dto'] === undefined) return false;
    if (!('organization_id' in value) || value['organization_id'] === undefined) return false;
    return true;
}

export function IPayrollCalendarPartnerRequestDtoFromJSON(json: any): IPayrollCalendarPartnerRequestDto {
    return IPayrollCalendarPartnerRequestDtoFromJSONTyped(json, false);
}

export function IPayrollCalendarPartnerRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPayrollCalendarPartnerRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'calendar_name': json['calendar_name'],
        'frequency_type': json['frequency_type'],
        'group_type': json['group_type'],
        'calculate_schedule_request_dto': ICalculateScheduleRequestDtoFromJSON(json['calculate_schedule_request_dto']),
        'plan_ids': json['plan_ids'] == null ? undefined : new Set(json['plan_ids']),
        'payroll_group_ids': json['payroll_group_ids'] == null ? undefined : new Set(json['payroll_group_ids']),
        'organization_id': json['organization_id'],
    };
}

export function IPayrollCalendarPartnerRequestDtoToJSON(json: any): IPayrollCalendarPartnerRequestDto {
    return IPayrollCalendarPartnerRequestDtoToJSONTyped(json, false);
}

export function IPayrollCalendarPartnerRequestDtoToJSONTyped(value?: IPayrollCalendarPartnerRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'calendar_name': value['calendar_name'],
        'frequency_type': value['frequency_type'],
        'group_type': value['group_type'],
        'calculate_schedule_request_dto': ICalculateScheduleRequestDtoToJSON(value['calculate_schedule_request_dto']),
        'plan_ids': value['plan_ids'] == null ? undefined : Array.from(value['plan_ids'] as Set<any>),
        'payroll_group_ids': value['payroll_group_ids'] == null ? undefined : Array.from(value['payroll_group_ids'] as Set<any>),
        'organization_id': value['organization_id'],
    };
}

